import _ from 'lodash';

export const money = amount =>
  parseFloat((Math.round(Number(amount) * 100) / 100).toString()).toFixed(2);

export const calculateLineAmount = (quantity, unitPrice, discount) => {
  let amount = 0;

  if (quantity > 0) {
    const discountPercent = discount / 100;
    const unitPriceWithDiscount = unitPrice - unitPrice * discountPercent;
    amount = quantity * unitPriceWithDiscount;
  }

  return money(amount);
};

export const calculateTotals = (taxRate, amount) => {
  // Add vat to amount
  const vat = taxRate.effectiveRate;

  let total = amount + amount * vat / 100;
  let subTotal = amount;
  let subTotalVat = subTotal * vat / 100;

  return {
    total: money(total),
    subTotal: money(subTotal),
    subTotalVat: money(subTotalVat)
  };
};

export const formatMoney = (value: number) =>
  value &&
  Number(value)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,'); // Returns value in this format: 12,345.67
